import React from 'react';

interface States {
}

interface Props {
    subtitle: String;
}

class Subtitle extends React.Component<Props, States> {

    state: States

    constructor(props: Props) {
        super(props)
        this.state = {}

    }

    render() {
        return (
            <div>
                <h3
                    className="subtitle">
                    {this.props.subtitle}
                </h3>
            </div>
        )
    }
}

export default Subtitle;
